const openNewWindowActions = [
  "redirect",
  "smsShare",
  "facebookShare",
  "messengerShare",
  "linkedInShare",
  "mailtoShare",
  "nativeMobileShare",
  "twitterShare",
  "whatsAppShare",
  "googleWalletLink",
  "appleWalletDownload",
];

const WIDGET_CONTAINER_SELECTOR = ".Widget-container";

export { openNewWindowActions, WIDGET_CONTAINER_SELECTOR };

export const QR_CODE_CHANNEL = "qr";
export const GOOGLE_WALLET_CHANNEL = "googleWallet";
export const GOOGLE_WALLET_CLICK_EVENT_NAME = "add_to_google_wallet";
export const APPLE_WALLET_CHANNEL = "appleWallet";
export const APPLE_WALLET_CLICK_EVENT_NAME = "add_to_apple_wallet";

// Product-specific channel names
export const PRODUCT_PURL_CHANNEL = "productPurl";
export const PRODUCT_QR_CODE_CHANNEL = "productQrCode";
export const PRODUCT_GOOGLE_WALLET_CHANNEL = "productGoogleWallet";
export const PRODUCT_APPLE_WALLET_CHANNEL = "productAppleWallet";
export const PRODUCT_SMS_CHANNEL = "productSms";
export const PRODUCT_EMAIL_CHANNEL = "productEmail";

export const PRODUCT_CHANNELS = [
  PRODUCT_PURL_CHANNEL,
  PRODUCT_QR_CODE_CHANNEL,
  PRODUCT_GOOGLE_WALLET_CHANNEL,
  PRODUCT_APPLE_WALLET_CHANNEL,
  PRODUCT_SMS_CHANNEL,
] as const;
